import { getUser } from "@/features/authenticate/utils/getUser";
import type { RouterContext } from "@/libs/@tanstack/react-router/types";
import { AppProvider } from "@/providers";
import { Outlet, createRootRouteWithContext } from "@tanstack/react-router";
import { Suspense, lazy } from "react";
import "@/libs/aws-amplify";

if (import.meta.env.DEV && import.meta.env.VITE_ENABLE_MSW === "true") {
	import("@/api/msw");
}

const TanStackRouterDevtools = import.meta.env.DEV
	? lazy(() =>
			import("@tanstack/router-devtools").then((res) => ({
				default: res.TanStackRouterDevtools,
			})),
		)
	: () => null;

const Root = () => {
	return (
		<AppProvider>
			<Outlet />
			<Suspense fallback={null}>
				<TanStackRouterDevtools position="bottom-right" />
			</Suspense>
		</AppProvider>
	);
};

export const Route = createRootRouteWithContext<RouterContext>()({
	beforeLoad: async ({ context }: { context: RouterContext }) => {
		const user = await getUser();

		context.auth.user = user;
		context.auth.isAuthenticated = user !== null;
	},
	component: Root,
	errorComponent: () => <div>エラーが発生しました</div>,
	notFoundComponent: () => <div>ページが見つかりません</div>,
	onError: (err) => {
		// TODO: 仮置き
		// biome-ignore lint/suspicious/noConsole: <explanation>
		console.error(err);
	},
});
